import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import {
    FaArrowLeft,
    FaArrowRight,
    FaExternalLinkAlt,
    FaCode,
    FaGlobe,
    FaDatabase,
    FaMobileAlt,
    FaServer,
    FaRocket,
    FaLaptopCode,
    FaLayerGroup,
} from "react-icons/fa";

import clientOne from "./images/salvationweb.jpg";
import clientTwo from "./images/zionpraisesite.jpg";
import clientThree from "./images/excellentkids.jpg";
import clientFour from "./images/janaweb.jpg";
import clientFive from "./images/royalpriestweb.jpg";

const clients = [
    {
        id: 1,
        name: "Salvation In Christ",
        category: "School Management System",
        image: clientOne,
        description:
            "A complete digital school management platform designed to manage students, teachers, academics, attendance, fees, communication, and school operations.",

        website: "#",
    },
    {
        id: 2,
        name: "Zion Praise Academy",
        category: "Education Technology",
        image: clientTwo,
        description:
            "A modern digital platform designed to bring school administration, academic management, student services, and communication into one connected system.",

        website: "#",
    },
    {
        id: 3,
        name: "Excellent Kids Foundation",
        category: "Education Technology",
        image: clientThree,
        description:
            "A modern digital platform designed to bring school administration, academic management, student services, and communication into one connected system.",

        website: "#",
    },
    {
        id: 4,
        name: "Jana Williams Educational Foundation",
        category: "Website & Digital Platform",
        image: clientFour,
        description:
            "A professional digital presence designed to communicate the organization's mission, programs, services, and educational initiatives.",

        website: "#",
    },
    {
        id: 5,
        name: "Royal Priesthood Academy",
        category: "School Technology",
        image: clientFive,
        description:
            "A technology-driven school platform focused on providing modern digital tools for administration, academics, communication, and school management.",

        website: "#",
    },
];

const About = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const visibleClients = 4;

    const hasMoreThanFour = clients.length > visibleClients;

    /*
     * Desktop pages:
     *
     * 5 clients:
     * Page 0 = clients 1,2,3,4
     * Page 1 = client 5 only
     *
     * 6 clients:
     * Page 0 = clients 1,2,3,4
     * Page 1 = clients 5,6
     *
     * 7 clients:
     * Page 0 = clients 1,2,3,4
     * Page 1 = clients 5,6,7
     *
     * 8 clients:
     * Page 0 = clients 1,2,3,4
     * Page 1 = clients 5,6,7,8
     *
     * This prevents the cards from shifting one-by-one.
     */
    const desktopPages = [];

    for (
        let i = 0;
        i < clients.length;
        i += visibleClients
    ) {
        desktopPages.push(
            clients.slice(i, i + visibleClients)
        );
    }

    const totalDesktopPages = desktopPages.length;

    const currentDesktopClients =
        desktopPages[currentIndex] || desktopPages[0];

    useEffect(() => {
        AOS.init({
            duration: 900,
            once: true,
            offset: 80,
            easing: "ease-out-cubic",
        });
    }, []);

    const goNext = () => {
        setCurrentIndex((previous) => {
            if (previous >= totalDesktopPages - 1) {
                return previous;
            }

            return previous + 1;
        });
    };

    const goPrevious = () => {
        setCurrentIndex((previous) => {
            if (previous <= 0) {
                return previous;
            }

            return previous - 1;
        });
    };

    const mobileNext = () => {
        setCurrentIndex((previous) => {
            if (previous >= clients.length - 1) {
                return 0;
            }

            return previous + 1;
        });
    };

    const mobilePrevious = () => {
        setCurrentIndex((previous) => {
            if (previous <= 0) {
                return clients.length - 1;
            }

            return previous - 1;
        });
    };

    const currentMobileClient =
        clients[currentIndex] || clients[0];

    const desktopStart =
        currentIndex * visibleClients + 1;

    const desktopEnd = Math.min(
        (currentIndex + 1) * visibleClients,
        clients.length
    );

    return (
        <main className="polu-clients-page">

            <section className="polu-client-hero">
                <div className="hero-background-grid"></div>

                <div className="hero-orange-orb orb-one"></div>
                <div className="hero-orange-orb orb-two"></div>

                <div
                    className="polu-client-container"
                    data-aos="fade-up"
                >
                    <div className="hero-label">
                        <span></span>

                        OUR DIGITAL WORK

                        <span></span>
                    </div>

                    <h1>
                        Technology Built
                        <strong>
                            For Real People.
                        </strong>
                    </h1>

                    <p>
                        From websites and software systems to
                        databases, APIs, automation, and complete
                        digital platforms, POLU-TECH works with
                        organizations to turn ideas into technology
                        that works.
                    </p>

                    <div className="hero-stats">
                        <div>
                            <strong>
                                {clients.length}+
                            </strong>

                            <span>
                                Projects & Clients
                            </span>
                        </div>

                        <div>
                            <strong>
                                100%
                            </strong>

                            <span>
                                Digital Focus
                            </span>
                        </div>

                        <div>
                            <strong>
                                ∞
                            </strong>

                            <span>
                                Possibilities
                            </span>
                        </div>
                    </div>
                </div>

                <div className="hero-bottom-line"></div>
            </section>

            <section className="polu-client-showcase">

                <div
                    className="polu-client-container"
                    data-aos="fade-up"
                >
                    <div className="showcase-heading">

                        <div>
                            <span className="section-kicker">
                                OUR CLIENTS
                            </span>

                            <h2>
                                Digital Experiences
                                <span>
                                    We've Built.
                                </span>
                            </h2>
                        </div>

                        <p>
                            Every project is different. We work
                            closely with our clients to design,
                            develop, and deploy technology that
                            solves real problems and creates
                            measurable value.
                        </p>
                    </div>

                    {hasMoreThanFour && (
                        <div className="desktop-slider-controls">

                            <button
                                type="button"
                                onClick={goPrevious}
                                disabled={currentIndex === 0}
                                aria-label="Previous clients"
                                className={
                                    currentIndex === 0
                                        ? "disabled"
                                        : ""
                                }
                            >
                                <FaArrowLeft />
                            </button>

                            <span>
                                {String(
                                    desktopStart
                                ).padStart(2, "0")}

                                {" — "}

                                {String(
                                    desktopEnd
                                ).padStart(2, "0")}

                                {" / "}

                                {String(
                                    clients.length
                                ).padStart(2, "0")}
                            </span>

                            <button
                                type="button"
                                onClick={goNext}
                                disabled={
                                    currentIndex ===
                                    totalDesktopPages - 1
                                }
                                aria-label="Next clients"
                                className={
                                    currentIndex ===
                                    totalDesktopPages - 1
                                        ? "disabled"
                                        : ""
                                }
                            >
                                <FaArrowRight />
                            </button>

                        </div>
                    )}

                    <div
                        className={`desktop-client-grid ${
                            currentDesktopClients.length === 1
                                ? "single-client"
                                : ""
                        } ${
                            currentDesktopClients.length === 2
                                ? "two-clients"
                                : ""
                        } ${
                            currentDesktopClients.length === 3
                                ? "three-clients"
                                : ""
                        } ${
                            currentDesktopClients.length === 4
                                ? "four-clients"
                                : ""
                        }`}
                    >
                        {currentDesktopClients.map(
                            (client, index) => (
                                <article
                                    className="client-project-card"
                                    key={client.id}
                                    data-aos="fade-up"
                                    data-aos-delay={
                                        index * 100
                                    }
                                >
                                    <div className="client-image-wrapper">

                                        <img
                                            src={client.image}
                                            alt={`${client.name} project`}
                                        />

                                        <div className="client-image-overlay"></div>

                                        <div className="client-project-number">
                                            {String(
                                                client.id
                                            ).padStart(2, "0")}
                                        </div>

                                        <div className="client-view-icon">
                                            <FaExternalLinkAlt />
                                        </div>
                                    </div>

                                    <div className="client-project-content">

                                        <span className="client-category">
                                            {client.category}
                                        </span>

                                        <h3>
                                            {client.name}
                                        </h3>

                                        <p>
                                            {client.description}
                                        </p>

                                        

                                        <a
                                            href={
                                                client.website
                                            }
                                            className="client-project-link"
                                        >
                                            View Project

                                            <FaArrowRight />
                                        </a>
                                    </div>
                                </article>
                            )
                        )}
                    </div>

                    <div className="mobile-client-slider">

                        <article className="mobile-client-card">

                            <div className="mobile-client-image">

                                <img
                                    src={
                                        currentMobileClient.image
                                    }
                                    alt={
                                        currentMobileClient.name
                                    }
                                />

                                <div className="mobile-image-overlay"></div>

                                <span>
                                    {String(
                                        currentMobileClient.id
                                    ).padStart(2, "0")}
                                </span>
                            </div>

                            <div className="mobile-client-content">

                                <small>
                                    {
                                        currentMobileClient.category
                                    }
                                </small>

                                <h3>
                                    {
                                        currentMobileClient.name
                                    }
                                </h3>

                                <p>
                                    {
                                        currentMobileClient.description
                                    }
                                </p>

                        

                                <a
                                    href={
                                        currentMobileClient.website
                                    }
                                    className="client-project-link"
                                >
                                    View Project

                                    <FaArrowRight />
                                </a>
                            </div>
                        </article>

                        {clients.length > 1 && (
                            <div className="mobile-slider-controls">

                                <button
                                    type="button"
                                    onClick={
                                        mobilePrevious
                                    }
                                    aria-label="Previous project"
                                >
                                    <FaArrowLeft />
                                </button>

                                <div className="mobile-slider-dots">
                                    {clients.map(
                                        (_, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                className={
                                                    index ===
                                                    currentIndex
                                                        ? "active"
                                                        : ""
                                                }
                                                onClick={() =>
                                                    setCurrentIndex(
                                                        index
                                                    )
                                                }
                                                aria-label={`Show project ${
                                                    index + 1
                                                }`}
                                            />
                                        )
                                    )}
                                </div>

                                <button
                                    type="button"
                                    onClick={
                                        mobileNext
                                    }
                                    aria-label="Next project"
                                >
                                    <FaArrowRight />
                                </button>

                            </div>
                        )}
                    </div>
                </div>
            </section>

            <section className="polu-capabilities">

                <div
                    className="polu-client-container"
                    data-aos="fade-up"
                >
                    <div className="capabilities-heading">
                        <span className="section-kicker">
                            WHAT WE DELIVER
                        </span>

                        <h2>
                            More Than
                            <span>
                                Just Code.
                            </span>
                        </h2>

                        <p>
                            We combine engineering, design,
                            data, infrastructure, and strategy
                            to build complete digital solutions.
                        </p>
                    </div>

                    <div className="capabilities-grid">

                        <div className="capability-item">
                            <div>
                                <FaCode />
                            </div>

                            <h3>
                                Programming
                            </h3>

                            <p>
                                Modern frontend and backend
                                development for powerful
                                applications.
                            </p>
                        </div>

                        <div className="capability-item">
                            <div>
                                <FaGlobe />
                            </div>

                            <h3>
                                Web Design
                            </h3>

                            <p>
                                Professional, responsive,
                                and high-performance websites.
                            </p>
                        </div>

                        <div className="capability-item">
                            <div>
                                <FaDatabase />
                            </div>

                            <h3>
                                Data Systems
                            </h3>

                            <p>
                                Structured databases and
                                information management platforms.
                            </p>
                        </div>

                        <div className="capability-item">
                            <div>
                                <FaServer />
                            </div>

                            <h3>
                                APIs & Backend
                            </h3>

                            <p>
                                Secure APIs and scalable
                                server-side infrastructure.
                            </p>
                        </div>

                        <div className="capability-item">
                            <div>
                                <FaMobileAlt />
                            </div>

                            <h3>
                                Applications
                            </h3>

                            <p>
                                Digital applications designed
                                for modern users and devices.
                            </p>
                        </div>

                        <div className="capability-item">
                            <div>
                                <FaRocket />
                            </div>

                            <h3>
                                Innovation
                            </h3>

                            <p>
                                Technology solutions designed
                                to support growth and efficiency.
                            </p>
                        </div>

                    </div>
                </div>
            </section>

            <section className="polu-process">

                <div className="polu-client-container">

                    <div
                        className="process-heading"
                        data-aos="fade-up"
                    >
                        <span className="section-kicker">
                            OUR PROCESS
                        </span>

                        <h2>
                            From Idea
                            <span>
                                To Reality.
                            </span>
                        </h2>
                    </div>

                    <div className="process-grid">

                        <div
                            className="process-step"
                            data-aos="fade-up"
                        >
                            <span>
                                01
                            </span>

                            <FaLaptopCode />

                            <h3>
                                Discover
                            </h3>

                            <p>
                                We understand your goals,
                                challenges, users, and
                                requirements.
                            </p>
                        </div>

                        <div
                            className="process-step"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            <span>
                                02
                            </span>

                            <FaLayerGroup />

                            <h3>
                                Design
                            </h3>

                            <p>
                                We transform ideas into clear,
                                practical, and engaging digital
                                experiences.
                            </p>
                        </div>

                        <div
                            className="process-step"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <span>
                                03
                            </span>

                            <FaCode />

                            <h3>
                                Develop
                            </h3>

                            <p>
                                Our developers build reliable
                                systems using modern technologies.
                            </p>
                        </div>

                        <div
                            className="process-step"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <span>
                                04
                            </span>

                            <FaRocket />

                            <h3>
                                Launch
                            </h3>

                            <p>
                                We deploy, test, optimize, and
                                prepare your technology for growth.
                            </p>
                        </div>

                    </div>
                </div>
            </section>

            <section
                className="polu-client-cta"
                data-aos="fade-up"
            >
                <div className="cta-glow"></div>

                <div className="cta-inner">

                    <div className="cta-icon">
                        <FaRocket />
                    </div>

                    <div>
                        <span>
                            HAVE AN IDEA?
                        </span>

                        <h2>
                            Let's Build Something
                            <strong>
                                Powerful.
                            </strong>
                        </h2>

                        <p>
                            Your next website, application,
                            database, business system, or digital
                            platform could start with one conversation.
                        </p>
                    </div>

                    <a
                        href="#contact"
                        className="cta-button"
                    >
                        Start a Project

                        <FaArrowRight />
                    </a>

                </div>
            </section>

            <style>{`

                .polu-clients-page {
                    --orange: #f97316;
                    --orange-light: #fb923c;
                    --orange-dark: #c2410c;
                    --black: #171717;
                    --charcoal: #292929;
                    --gray: #6b7280;
                    --light-gray: #f4f4f4;
                    --border: #e7e7e7;
                    --white: #ffffff;

                    width: 100%;
                    overflow: hidden;
                    background: #ffffff;
                    color: var(--black);
                    font-family:
                        "Poppins",
                        "Inter",
                        Arial,
                        sans-serif;
                }

                .polu-client-container {
                    width: min(1380px, 92%);
                    margin: 0 auto;
                }

                .polu-client-hero {
                    position: relative;
                    min-height: 620px;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    background:
                        radial-gradient(
                            circle at 82% 35%,
                            rgba(249, 115, 22, 0.13),
                            transparent 25%
                        ),
                        linear-gradient(
                            135deg,
                            #ffffff 0%,
                            #fafafa 55%,
                            #f2f2f2 100%
                        );
                }

                .hero-background-grid {
                    position: absolute;
                    inset: 0;
                    opacity: 0.55;
                    background-image:
                        linear-gradient(
                            #e9e9e9 1px,
                            transparent 1px
                        ),
                        linear-gradient(
                            90deg,
                            #e9e9e9 1px,
                            transparent 1px
                        );
                    background-size: 70px 70px;
                    mask-image:
                        linear-gradient(
                            to right,
                            black,
                            transparent 85%
                        );
                }

                .hero-orange-orb {
                    position: absolute;
                    border-radius: 50%;
                    background: var(--orange);
                    filter: blur(100px);
                    opacity: 0.1;
                    animation:
                        heroOrbMove
                        8s ease-in-out infinite;
                }

                .orb-one {
                    width: 360px;
                    height: 360px;
                    right: -100px;
                    top: -100px;
                }

                .orb-two {
                    width: 240px;
                    height: 240px;
                    left: -100px;
                    bottom: -100px;
                    animation-delay: 2s;
                }

                @keyframes heroOrbMove {
                    0%,
                    100% {
                        transform:
                            translate(0, 0)
                            scale(1);
                    }

                    50% {
                        transform:
                            translate(-30px, 25px)
                            scale(1.12);
                    }
                }

                .polu-client-hero
                    .polu-client-container {
                    position: relative;
                    z-index: 2;
                    padding: 100px 0;
                }

                .hero-label {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 25px;
                    color: var(--orange);
                    font-size: 11px;
                    font-weight: 800;
                    letter-spacing: 4px;
                }

                .hero-label span {
                    width: 42px;
                    height: 2px;
                    background: var(--orange);
                }

                .hero-label span:last-child {
                    width: 10px;
                }

                .polu-client-hero h1 {
                    max-width: 950px;
                    margin: 0;
                    color: #171717;
                    font-size: clamp(
                        55px,
                        8vw,
                        110px
                    );
                    line-height: 0.95;
                    font-weight: 800;
                    letter-spacing: -6px;
                }

                .polu-client-hero h1 strong {
                    display: block;
                    color: var(--orange);
                }

                .polu-client-hero p {
                    max-width: 730px;
                    margin: 35px 0 0;
                    color: var(--gray);
                    font-size: 16px;
                    line-height: 1.9;
                }

                .hero-stats {
                    display: flex;
                    gap: 60px;
                    margin-top: 50px;
                }

                .hero-stats div {
                    display: flex;
                    flex-direction: column;
                }

                .hero-stats strong {
                    color: var(--black);
                    font-size: 28px;
                    line-height: 1;
                }

                .hero-stats span {
                    margin-top: 8px;
                    color: #8b8b8b;
                    font-size: 10px;
                    font-weight: 700;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                }

                .hero-bottom-line {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 4px;
                    background:
                        linear-gradient(
                            90deg,
                            transparent,
                            var(--orange),
                            transparent
                        );
                }

                .polu-client-showcase {
                    position: relative;
                    padding: 120px 0;
                    background: #ffffff;
                }

                .showcase-heading {
                    display: grid;
                    grid-template-columns:
                        minmax(0, 1fr)
                        minmax(300px, 0.65fr);
                    gap: 80px;
                    align-items: end;
                    margin-bottom: 50px;
                }

                .section-kicker {
                    display: inline-block;
                    color: var(--orange);
                    font-size: 10px;
                    font-weight: 800;
                    letter-spacing: 3px;
                }

                .showcase-heading h2,
                .capabilities-heading h2,
                .process-heading h2 {
                    margin: 12px 0 0;
                    color: var(--black);
                    font-size: clamp(
                        38px,
                        5vw,
                        65px
                    );
                    line-height: 1;
                    letter-spacing: -3px;
                }

                .showcase-heading h2 span,
                .capabilities-heading h2 span,
                .process-heading h2 span {
                    display: block;
                    color: #a0a0a0;
                }

                .showcase-heading p {
                    margin: 0;
                    color: var(--gray);
                    font-size: 14px;
                    line-height: 1.9;
                }

                .desktop-slider-controls {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 25px;
                }

                .desktop-slider-controls button {
                    width: 45px;
                    height: 45px;
                    display: grid;
                    place-items: center;
                    border: 1px solid #dddddd;
                    background: #ffffff;
                    color: var(--black);
                    cursor: pointer;
                    transition:
                        0.3s ease;
                }

                .desktop-slider-controls button:hover:not(.disabled) {
                    border-color: var(--orange);
                    background: var(--orange);
                    color: #ffffff;
                    transform: translateY(-2px);
                }

                .desktop-slider-controls button.disabled {
                    opacity: 0.35;
                    cursor: not-allowed;
                    transform: none;
                }

                .desktop-slider-controls span {
                    color: #999999;
                    font-family: monospace;
                    font-size: 11px;
                    letter-spacing: 2px;
                    min-width: 100px;
                    text-align: center;
                }

                /*
                 * DESKTOP CLIENT LAYOUT
                 *
                 * Four = four equal cards
                 * Three = three cards centered
                 * Two = two cards centered
                 * One = one card centered
                 */

                .desktop-client-grid {
                    display: grid;
                    gap: 18px;
                    align-items: stretch;
                    justify-content: center;
                }

                .desktop-client-grid.four-clients {
                    grid-template-columns:
                        repeat(4, minmax(0, 1fr));
                }

                .desktop-client-grid.three-clients {
                    grid-template-columns:
                        repeat(3, minmax(260px, 350px));
                }

                .desktop-client-grid.two-clients {
                    grid-template-columns:
                        repeat(2, minmax(280px, 390px));
                }

                .desktop-client-grid.single-client {
                    grid-template-columns:
                        minmax(300px, 390px);
                }

                .client-project-card {
                    position: relative;
                    overflow: hidden;
                    border: 1px solid var(--border);
                    background: #ffffff;
                    box-shadow:
                        0 10px 40px
                        rgba(0, 0, 0, 0.045);
                    transition:
                        transform 0.4s ease,
                        box-shadow 0.4s ease,
                        border-color 0.4s ease;
                }

                .client-project-card:hover {
                    transform:
                        translateY(-9px);
                    border-color:
                        rgba(249, 115, 22, 0.35);
                    box-shadow:
                        0 25px 60px
                        rgba(0, 0, 0, 0.09);
                }

                .client-image-wrapper {
                    position: relative;
                    height: 235px;
                    overflow: hidden;
                    background: #eeeeee;
                }

                .client-image-wrapper img {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                    filter: saturate(0.9);
                    transition:
                        transform 0.7s ease,
                        filter 0.7s ease;
                }

                .client-project-card:hover
                    .client-image-wrapper img {
                    transform: scale(1.08);
                    filter: saturate(1.15);
                }

                .client-image-overlay {
                    position: absolute;
                    inset: 0;
                    background:
                        linear-gradient(
                            180deg,
                            transparent 35%,
                            rgba(0, 0, 0, 0.55)
                        );
                }

                .client-project-number {
                    position: absolute;
                    top: 18px;
                    left: 18px;
                    display: grid;
                    place-items: center;
                    width: 36px;
                    height: 36px;
                    background: rgba(
                        255,
                        255,
                        255,
                        0.92
                    );
                    color: var(--orange);
                    font-family: monospace;
                    font-size: 11px;
                    font-weight: 800;
                }

                .client-view-icon {
                    position: absolute;
                    right: 18px;
                    bottom: 18px;
                    width: 40px;
                    height: 40px;
                    display: grid;
                    place-items: center;
                    background: var(--orange);
                    color: #ffffff;
                    transform:
                        translateY(10px);
                    opacity: 0;
                    transition:
                        0.3s ease;
                }

                .client-project-card:hover
                    .client-view-icon {
                    opacity: 1;
                    transform:
                        translateY(0);
                }

                .client-project-content {
                    padding: 25px;
                }

                .client-category {
                    color: var(--orange);
                    font-size: 9px;
                    font-weight: 800;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                }

                .client-project-content h3 {
                    margin: 8px 0 12px;
                    color: var(--black);
                    font-size: 20px;
                    line-height: 1.2;
                }

                .client-project-content p {
                    min-height: 105px;
                    margin: 0;
                    color: #777777;
                    font-size: 11px;
                    line-height: 1.8;
                }

                .technology-tags {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 6px;
                    margin-top: 18px;
                }

                .technology-tags span {
                    padding: 6px 8px;
                    border: 1px solid #eeeeee;
                    background: #fafafa;
                    color: #777777;
                    font-size: 8px;
                    font-weight: 700;
                }

                .client-project-link {
                    display: inline-flex;
                    align-items: center;
                    gap: 9px;
                    margin-top: 22px;
                    color: var(--black);
                    font-size: 10px;
                    font-weight: 800;
                    text-decoration: none;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    transition:
                        0.3s ease;
                }

                .client-project-link svg {
                    color: var(--orange);
                    transition:
                        0.3s ease;
                }

                .client-project-link:hover {
                    color: var(--orange);
                }

                .client-project-link:hover svg {
                    transform:
                        translateX(5px);
                }

                .mobile-client-slider {
                    display: none;
                }

                .polu-capabilities {
                    padding: 120px 0;
                    background: #f7f7f7;
                    border-top: 1px solid #eeeeee;
                    border-bottom: 1px solid #eeeeee;
                }

                .capabilities-heading {
                    max-width: 700px;
                    margin-bottom: 55px;
                }

                .capabilities-heading p {
                    max-width: 600px;
                    margin-top: 25px;
                    color: var(--gray);
                    font-size: 14px;
                    line-height: 1.9;
                }

                .capabilities-grid {
                    display: grid;
                    grid-template-columns:
                        repeat(3, minmax(0, 1fr));
                    gap: 1px;
                    overflow: hidden;
                    border: 1px solid #e4e4e4;
                    background: #e4e4e4;
                }

                .capability-item {
                    padding: 35px;
                    background: #ffffff;
                    transition:
                        0.35s ease;
                }

                .capability-item:hover {
                    background:
                        linear-gradient(
                            135deg,
                            #ffffff,
                            #fff8f3
                        );
                }

                .capability-item > div {
                    width: 50px;
                    height: 50px;
                    display: grid;
                    place-items: center;
                    margin-bottom: 25px;
                    background: #fff3eb;
                    color: var(--orange);
                    font-size: 18px;
                }

                .capability-item h3 {
                    margin: 0 0 10px;
                    font-size: 18px;
                }

                .capability-item p {
                    margin: 0;
                    color: #777777;
                    font-size: 12px;
                    line-height: 1.8;
                }

                .polu-process {
                    padding: 120px 0;
                    background: #ffffff;
                }

                .process-heading {
                    margin-bottom: 55px;
                }

                .process-grid {
                    display: grid;
                    grid-template-columns:
                        repeat(4, minmax(0, 1fr));
                    border-top: 1px solid #e5e5e5;
                    border-left: 1px solid #e5e5e5;
                }

                .process-step {
                    position: relative;
                    min-height: 300px;
                    padding: 35px;
                    border-right: 1px solid #e5e5e5;
                    border-bottom: 1px solid #e5e5e5;
                    overflow: hidden;
                }

                .process-step > span {
                    position: absolute;
                    top: 25px;
                    right: 25px;
                    color: #dddddd;
                    font-family: monospace;
                    font-size: 13px;
                }

                .process-step > svg {
                    margin-top: 35px;
                    color: var(--orange);
                    font-size: 27px;
                }

                .process-step h3 {
                    margin: 30px 0 10px;
                    font-size: 21px;
                }

                .process-step p {
                    margin: 0;
                    color: #777777;
                    font-size: 12px;
                    line-height: 1.8;
                }

                .process-step::after {
                    position: absolute;
                    content: "";
                    left: 0;
                    bottom: 0;
                    width: 0;
                    height: 3px;
                    background: var(--orange);
                    transition:
                        width 0.4s ease;
                }

                .process-step:hover::after {
                    width: 100%;
                }

                .polu-client-cta {
                    position: relative;
                    overflow: hidden;
                    margin: 0 0 60px;
                    background: var(--black);
                    color: #ffffff;
                }

                .cta-glow {
                    position: absolute;
                    width: 400px;
                    height: 400px;
                    right: 10%;
                    top: -250px;
                    border-radius: 50%;
                    background: var(--orange);
                    filter: blur(110px);
                    opacity: 0.18;
                }

                .cta-inner {
                    position: relative;
                    width: min(1380px, 92%);
                    margin: 0 auto;
                    min-height: 250px;
                    display: grid;
                    grid-template-columns:
                        auto 1fr auto;
                    gap: 30px;
                    align-items: center;
                    padding: 45px 0;
                }

                .cta-icon {
                    width: 65px;
                    height: 65px;
                    display: grid;
                    place-items: center;
                    border: 1px solid
                        rgba(249, 115, 22, 0.5);
                    color: var(--orange);
                    font-size: 22px;
                }

                .cta-inner > div:nth-child(2) span {
                    color: var(--orange);
                    font-size: 9px;
                    font-weight: 800;
                    letter-spacing: 3px;
                }

                .cta-inner h2 {
                    margin: 7px 0;
                    font-size: 30px;
                    line-height: 1.15;
                }

                .cta-inner h2 strong {
                    color: var(--orange);
                }

                .cta-inner p {
                    max-width: 650px;
                    margin: 0;
                    color: #929292;
                    font-size: 12px;
                    line-height: 1.8;
                }

                .cta-button {
                    display: inline-flex;
                    align-items: center;
                    gap: 13px;
                    padding: 16px 23px;
                    background: var(--orange);
                    color: #ffffff;
                    font-size: 10px;
                    font-weight: 800;
                    text-decoration: none;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    transition:
                        0.3s ease;
                }

                .cta-button:hover {
                    background: var(--orange-light);
                    transform:
                        translateY(-3px);
                    box-shadow:
                        0 15px 30px
                        rgba(249, 115, 22, 0.2);
                }

                @media (max-width: 1200px) {

                    .desktop-client-grid.four-clients {
                        grid-template-columns:
                            repeat(2, minmax(0, 1fr));
                    }

                    .desktop-client-grid.three-clients {
                        grid-template-columns:
                            repeat(3, minmax(220px, 1fr));
                    }

                    .desktop-client-grid.two-clients {
                        grid-template-columns:
                            repeat(2, minmax(260px, 380px));
                    }

                    .desktop-client-grid.single-client {
                        grid-template-columns:
                            minmax(280px, 380px);
                    }

                    .process-grid {
                        grid-template-columns:
                            repeat(2, minmax(0, 1fr));
                    }

                    .capabilities-grid {
                        grid-template-columns:
                            repeat(2, minmax(0, 1fr));
                    }
                }

                @media (max-width: 768px) {

                    .polu-client-hero {
                        min-height: 580px;
                    }

                    .polu-client-hero
                        .polu-client-container {
                        padding:
                            80px 0;
                    }

                    .polu-client-hero h1 {
                        font-size: 55px;
                        letter-spacing: -3px;
                    }

                    .polu-client-hero p {
                        font-size: 14px;
                    }

                    .hero-stats {
                        gap: 25px;
                    }

                    .hero-stats strong {
                        font-size: 22px;
                    }

                    .hero-stats span {
                        font-size: 8px;
                    }

                    .polu-client-showcase,
                    .polu-capabilities,
                    .polu-process {
                        padding:
                            80px 0;
                    }

                    .showcase-heading {
                        display: block;
                        margin-bottom: 35px;
                    }

                    .showcase-heading p {
                        margin-top: 25px;
                    }

                    .desktop-client-grid,
                    .desktop-slider-controls {
                        display: none;
                    }

                    .mobile-client-slider {
                        display: block;
                    }

                    .mobile-client-card {
                        overflow: hidden;
                        border: 1px solid #e5e5e5;
                        background: #ffffff;
                        box-shadow:
                            0 15px 45px
                            rgba(0, 0, 0, 0.06);
                    }

                    .mobile-client-image {
                        position: relative;
                        height: 270px;
                        overflow: hidden;
                    }

                    .mobile-client-image img {
                        width: 100%;
                        height: 100%;
                        display: block;
                        object-fit: cover;
                    }

                    .mobile-image-overlay {
                        position: absolute;
                        inset: 0;
                        background:
                            linear-gradient(
                                180deg,
                                transparent 35%,
                                rgba(0, 0, 0, 0.65)
                            );
                    }

                    .mobile-client-image > span {
                        position: absolute;
                        top: 18px;
                        left: 18px;
                        width: 38px;
                        height: 38px;
                        display: grid;
                        place-items: center;
                        background: #ffffff;
                        color: var(--orange);
                        font-family: monospace;
                        font-size: 11px;
                    }

                    .mobile-client-content {
                        padding: 28px;
                    }

                    .mobile-client-content small {
                        color: var(--orange);
                        font-size: 9px;
                        font-weight: 800;
                        letter-spacing: 2px;
                        text-transform: uppercase;
                    }

                    .mobile-client-content h3 {
                        margin: 8px 0 13px;
                        font-size: 25px;
                    }

                    .mobile-client-content p {
                        margin: 0;
                        color: #777777;
                        font-size: 12px;
                        line-height: 1.8;
                    }

                    .mobile-slider-controls {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 25px;
                    }

                    .mobile-slider-controls > button {
                        width: 45px;
                        height: 45px;
                        display: grid;
                        place-items: center;
                        border: 1px solid #dddddd;
                        background: #ffffff;
                        color: var(--black);
                        cursor: pointer;
                    }

                    .mobile-slider-controls > button:hover {
                        background: var(--orange);
                        border-color: var(--orange);
                        color: #ffffff;
                    }

                    .mobile-slider-dots {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                    }

                    .mobile-slider-dots button {
                        width: 6px;
                        height: 6px;
                        padding: 0;
                        border: 0;
                        border-radius: 50%;
                        background: #d2d2d2;
                        cursor: pointer;
                        transition:
                            0.3s ease;
                    }

                    .mobile-slider-dots button.active {
                        width: 22px;
                        border-radius: 10px;
                        background: var(--orange);
                    }

                    .capabilities-grid {
                        grid-template-columns: 1fr;
                    }

                    .process-grid {
                        grid-template-columns: 1fr;
                    }

                    .cta-inner {
                        grid-template-columns: 1fr;
                        gap: 22px;
                        padding:
                            45px 0;
                    }

                    .cta-button {
                        width: max-content;
                    }
                }

                @media (max-width: 480px) {

                    .polu-client-container {
                        width: 90%;
                    }

                    .polu-client-hero h1 {
                        font-size: 47px;
                    }

                    .hero-stats {
                        display: grid;
                        grid-template-columns:
                            repeat(3, 1fr);
                        gap: 15px;
                    }

                    .hero-stats strong {
                        font-size: 20px;
                    }

                    .showcase-heading h2,
                    .capabilities-heading h2,
                    .process-heading h2 {
                        font-size: 40px;
                        letter-spacing: -2px;
                    }

                    .mobile-client-image {
                        height: 230px;
                    }

                    .mobile-client-content {
                        padding: 23px;
                    }

                    .technology-tags span {
                        font-size: 7px;
                    }

                    .capability-item {
                        padding: 28px;
                    }

                    .process-step {
                        min-height: 260px;
                        padding: 28px;
                    }

                    .cta-inner h2 {
                        font-size: 25px;
                    }
                }

                @media (
                    prefers-reduced-motion:
                    reduce
                ) {
                    .polu-clients-page * ,
                    .polu-clients-page
                        *::before,
                    .polu-clients-page
                        *::after {
                        animation-duration:
                            0.01ms !important;

                        animation-iteration-count:
                            1 !important;

                        scroll-behavior:
                            auto !important;

                        transition-duration:
                            0.01ms !important;
                    }
                }

            `}</style>
        </main>
    );
};

export default About;